import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { PapiDeviation } from '@wix/da-papi-types';
import MoreActionsIcon from '@wix/da-ds/pkg/Icons/24x24/More';
import {
  useCreateVariationAction,
  useDreamupDeleteAction,
} from '../../../hooks';
import ActionBarIconButtonWithContextMenu from '../ActionBarIconButtonWithContextMenu';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';

interface Props {
  deviation: PapiDeviation;
}

const MoreMenuButton: FC<Props> = ({ deviation }) => {
  const { t } = useTranslation();
  const hasVideoCreator = useFlag('video_creator');
  const createVariationAction = useCreateVariationAction(deviation);

  const deleteAction = useDreamupDeleteAction(deviation, {
    biData: {
      sectionname: 'prompt_info',
      component: 'prompt',
    },
  });
  return (
    <ActionBarIconButtonWithContextMenu
      icon={MoreActionsIcon}
      items={[
        hasVideoCreator && {
          label: t('dreamup.modal.promptInfo.actions.createVariations.label'),
          disabled: createVariationAction.disabled,
          onClick: createVariationAction.onClick,
          biData: createVariationAction.biData,
        },
        {
          label: t('dreamup.modal.promptInfo.actions.delete.label'),
          onClick: deleteAction,
        },
      ]}
      aria-label={t('dreamup.modal.promptInfo.actions.more.label')}
      tooltipText={t('dreamup.modal.promptInfo.actions.more.label')}
    />
  );
};

MoreMenuButton.displayName = 'MoreMenuButton';

export default MoreMenuButton;
